import useGameParams from '~/client/components/Game/hooks/useGameParams';
import useDidMount from '~/client/hooks/lifecycle/useDidMount';
import useInterval from '~/client/hooks/useInterval';
import trackEvent from '~/shared/trackEvent';

const TEN_MINUTES = 600000;

const useGameEventEffects = () => {
  const { handle: gameName, categoryHandle: gameType } = useGameParams();
  useDidMount(() => trackEvent({ gameName, gameType }, 'gameStart'));
  useInterval(
    () => trackEvent({ gameName, gameType }, 'gameRunning'),
    TEN_MINUTES,
    [gameName, gameType],
  );
};

export default useGameEventEffects;
